import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ILoginRequest, ILoginResponse } from '../login.type';

/** Shared with `app.config.ts`'s `provideDsOnluyenAuth` token getter — keep in sync. */
export const AUTH_TOKEN_STORAGE_KEY = 'token';

/** Listed explicitly in `LOGIN_ROUTE.providers` (not root) so it shares that route's
 *  own `provideHttpClient()` — the login screen has no session yet, so it can't use
 *  the auth/loading/notify `HttpClient` scoped to the authenticated layout route. */
@Service({ autoProvided: false })
export class LoginApi {
  private readonly http = inject(HttpClient);

  async login(payload: ILoginRequest): Promise<ILoginResponse> {
    const res = await firstValueFrom(
      this.http.post<ILoginResponse>(environment.API_LOGIN, payload),
    );

    if (!res.access_token) {
      throw new Error(res?.message);
    }

    return res;
  }
}
